import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { DrawerRef, DRAWER_DATA_VAR } from 'mis-crystal-design-system/drawer';
import { DropdownItem } from 'mis-crystal-design-system/dropdown';
import { parseZone } from 'moment';
import { MyBookingsService } from 'src/app/bookings/my-bookings/my-bookings.service';
import { UtilService } from 'src/app/shared/services/util.service';

@Component({
  selector: 'app-invoice-single-details',
  templateUrl: './invoice-single-details.component.html',
  styleUrls: ['./invoice-single-details.component.scss']
})
export class InvoiceSingleDetailsComponent implements OnInit {

  public booking: any;
  public bookingSource: any;
  public bookingDestination: any;
  public noOfStops: any;
  public startTime: any; openD;
  public miscelleneousConfig: any;
  public ridersList: any;
  selectedItem: DropdownItem;
  sideMenu = false;
  stopsDetails: any;
  passanger: any[] = [];
  marshall: any;


  constructor(private drawerRef: DrawerRef,
              @Inject(DRAWER_DATA_VAR) private data: any,private myBookingService:MyBookingsService,
              private utilService: UtilService, private datePipe: DatePipe) {
    this.booking = data.data;
    this.miscelleneousConfig = data.miscelleneousConfig;
   }

  ngOnInit(): void {
    this.noOfStops = this.booking.stops.length;
    const ridersList = [];
    for (const stop of this.booking.stops) {
      if (Number(stop.priorityOrder) === 1) {
        this.bookingSource = stop;
      }
      if (Number(stop.priorityOrder) === this.noOfStops && this.noOfStops !== 1) {
        this.bookingDestination = stop;
      }
      for (const rider of stop.riders) {
        if (!ridersList.length) {
          ridersList.push(rider);
        } else {
          let riderExists = false;
          for (const newRider of ridersList) {
            if (newRider.personId === rider.personId) {
              riderExists = true;
              break;
            }
          }
          if (!riderExists) {
            ridersList.push(rider);
          }
        }
      }
    }
    this.ridersList = ridersList;
    this.startTime = this.getBookingTime(this.booking);
    this.stopsDetails = this.myBookingService.getStopsCompleteView(this.booking, this.miscelleneousConfig['12hrTimeFormat']);
    this.booking?.stops.forEach(stop => {
      stop?.riders.forEach(rider => {
        if (rider.riderType !== 'MARSHAL' && this.passanger.indexOf(rider) < 0 && rider.boardingType == "PickUp") {
          this.passanger.push(rider);
        }
        else if (rider.riderType === 'MARSHAL') {
        this.marshall = rider;
 }
      });
    });
  }

  getBookingTime(booking: any) {
    if (booking.startTime) {
      const dateMoment = this.utilService.getMoment(booking.startTime);
      return this.miscelleneousConfig['12hrTimeFormat'] === 'true' ?
      dateMoment.format('hh:mm A') : dateMoment.format('HH:mm');
    }

    return '--:--';
  }

  generateInvoive(){
    this.data.method('generate');
  }
  viewDocument(){
    this.data.method('viewDocument');
  }
  downloadInvoive(){
    this.data.method('download')
  }
  OpenTrack() {
    this.data.method('track');
  }

  edit() {
    this.data.method('edit');
  }

  close() {
    this.drawerRef.close();
  }
  transformDate(date: string) {
    const dateString = parseZone(date, 'DD/MM/YYYY').format();
    return this.datePipe.transform(dateString, 'EEE, MMM dd');
  }


}
